import { LOCALE_COOKIE, type Locale } from "./config";

// Idioma elegido por la persona. Lo usa proxy.ts para redirigir las URLs sin
// prefijo (links viejos, correos) al idioma correcto. 1 año.
export function saveLocalePreference(lang: Locale): void {
  try {
    document.cookie = `${LOCALE_COOKIE}=${lang}; path=/; max-age=31536000; samesite=lax`;
  } catch {
    // Cookies bloqueadas: el idioma igual queda en la URL.
  }
}

export function hasLocalePreference(): boolean {
  try {
    return document.cookie.split("; ").some((c) => c.startsWith(`${LOCALE_COOKIE}=`));
  } catch {
    return false;
  }
}
